export default "__VITE_ASSET__CyPN$WiI__"